import { LoadButton, NoDataMessage, isNoData } from '../shared';
import { WarrantyIcon } from '../icons';
import type { UseQueryResult } from '@tanstack/react-query';

interface WarrantyTabProps {
  query: UseQueryResult<any>;
  loadEnabled: boolean;
  onLoad: () => void;
  disabled?: boolean;
}

export function WarrantyTab({ query, loadEnabled, onLoad, disabled }: WarrantyTabProps) {
  return (
    <div>
      {!loadEnabled && (
        <div className="flex flex-col items-center justify-center py-12">
          <WarrantyIcon className="w-12 h-12 opacity-40 mb-4" />
          <p className="text-gray-400 text-sm mb-4">View factory warranty coverage details</p>
          <LoadButton label="Check Warranty" onClick={onLoad} isLoading={false} isLoaded={false} disabled={disabled} />
        </div>
      )}

      {query.isLoading && (
        <p className="text-gray-500 text-sm text-center py-8">Loading warranty information...</p>
      )}

      {query.error && !isNoData(query) && (
        <p className="text-red-400 text-sm text-center py-4">Error loading warranty data</p>
      )}

      {loadEnabled && !query.isLoading && !query.error && query.data && !query.data?.data?.warranty && (
        <NoDataMessage message="No warranty information available for this vehicle" />
      )}

      {query.data?.data?.warranty && typeof query.data.data.warranty === 'object' && (
        <div className="space-y-2">
          {Object.entries(query.data.data.warranty).map(([label, value]) => (
            <div key={label} className="flex items-center gap-3 p-3 bg-obdai-deep rounded-lg">
              <svg className="w-5 h-5 text-green-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              <span className="text-white">
                {(label as string).replace(/^Warranty - /, '')}: <span className="text-gray-300">{value as string}</span>
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
